import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchBoutique'
})
export class SearchBoutiquePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) return null;
    if(!args) return value;

    args = args.toLowerCase();

    return value.filter((item: any) => {
      return JSON.stringify(item.nom).toLowerCase().includes(args) || JSON.stringify(item.nomSecteur).toLowerCase().includes(args) ||JSON.stringify(item.bonus_sf).toLowerCase().includes(args);
    })
  }
}